export enum ChatSupportServerError {
  UNAUTHORIZED = 'Unauthorized.',
  FORBIDDEN = 'Forbidden.',
  ACCESS_DENIED = 'Acesso não autorizado.',
  TOKEN_NOT_CONFIGURED = 'CHAT_SUPPORT_API_TOKEN not configured.',
  SESSION_NOT_FOUND = 'Session not found',
  SESSION_NOT_OPEN = 'Session is not open',
  INVALID_ROLE = 'Invalid role',
  MESSAGE_REQUIRED = 'Message is required',
  MESSAGE_TOO_LONG = 'Message too long',
  RATE_LIMIT = 'Too many requests. Try again later.',
  AGENT_UNAVAILABLE = 'Chat agent unavailable',
  CHAT_DISABLED = 'Chat support is disabled.'
}

export const CHAT_SUPPORT_ERROR_TRANSLATIONS: Record<string, string> = {
  [ChatSupportServerError.UNAUTHORIZED]: 'Sessão não autorizada. Tente novamente.',
  [ChatSupportServerError.FORBIDDEN]: 'Acesso não autorizado.',
  [ChatSupportServerError.ACCESS_DENIED]: 'Acesso não autorizado.',
  [ChatSupportServerError.TOKEN_NOT_CONFIGURED]: 'Serviço temporariamente indisponível.',
  [ChatSupportServerError.SESSION_NOT_FOUND]: 'Sessão não encontrada.',
  [ChatSupportServerError.SESSION_NOT_OPEN]: 'A sessão foi encerrada.',
  [ChatSupportServerError.INVALID_ROLE]: 'Erro interno. Tente novamente.',
  [ChatSupportServerError.MESSAGE_REQUIRED]: 'Por favor, escreva uma mensagem.',
  [ChatSupportServerError.MESSAGE_TOO_LONG]: 'Mensagem muito longa.',
  [ChatSupportServerError.RATE_LIMIT]: 'Muitas requisições. Tente novamente em instantes.'
};

const STATUS_FALLBACK: Record<number, string> = {
  401: 'Sessão não autorizada. Tente novamente.',
  403: 'Acesso não autorizado.',
  404: 'Sessão não encontrada.',
  400: 'Requisição inválida.',
  429: 'Muitas requisições. Tente novamente em instantes.',
  500: 'Serviço temporariamente indisponível.'
};

export function getChatSupportErrorMessage(serverMessage: string, status: number): string {
  if (CHAT_SUPPORT_ERROR_TRANSLATIONS[serverMessage]) {
    return CHAT_SUPPORT_ERROR_TRANSLATIONS[serverMessage];
  }
  if (serverMessage.startsWith(ChatSupportServerError.AGENT_UNAVAILABLE)) {
    return 'Agente de atendimento indisponível. Tente novamente em instantes.';
  }
  return STATUS_FALLBACK[status] ?? 'Ocorreu um erro inesperado. Tente novamente.';
}
